import _ from 'lodash'
import React from 'react'
import { Box } from '@mui/system'
import Option from '../components/Option'
import { Answer, StudentAnswer } from './types'

interface Props {
    index: number
    handleSelect: (
        answer: Answer,
        question: { questionId: number; questionType: string },
    ) => void
    question?: any
    studentAnswers: StudentAnswer[]
}

const styles = {
    wrapper: {
        border: '1px solid #EDEFF4',
        borderRadius: '8px',
        p: 3,
        mb: 3,

        '@media screen and (max-width: 500px)': {
            p: 1,
        },
    },
}

const Question: React.FC<Props> = ({
    question = {},
    index,
    handleSelect,
    studentAnswers,
}) => {
    const selected = _.find(
        studentAnswers,
        (item) => item.questionId === question?.id,
    )

    return (
        <Box sx={styles.wrapper}>
            <Box mb={2}>
                <Box
                    sx={{
                        borderRadius: '50%',
                        border: '1px solid #e0e0e0',
                        mb: 1,
                        width: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '4px',
                    }}
                >
                    {index + 1}
                </Box>

                <div dangerouslySetInnerHTML={{ __html: question.content }} />
            </Box>

            <Box mb={2}>Выберите правильный термин</Box>

            <Box>
                {question?.answers?.map((answer, index) => (
                    <Option
                        key={answer.id}
                        index={index}
                        answer={answer}
                        selected={_.some(
                            selected?.answers,
                            (item) => item.answerId === answer.id,
                        )}
                        handleSelect={() =>
                            handleSelect(answer, {
                                questionId: question.id,
                                questionType: question.questionTypeEnum,
                            })
                        }
                    />
                ))}
            </Box>
        </Box>
    )
}

export default Question
